// extracted by mini-css-extract-plugin
module.exports = {"TPTransformerVTComponent":"TPTransformerVoltageSelector__TPTransformerVTComponent___3KPlF"};